import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const mainCategories = categories.slice(0, 8);
  const moreCategories = categories.slice(8);

  return (
    <section id="categories-section" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-12">
          <div className="flex-1">
            <p className="text-xs font-label font-semibold uppercase tracking-wider text-primary-500 mb-3">
              Organized Discovery
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 leading-tight">
              Browse the Complete<br />
              Hipobuy Spreadsheet Categories
            </h2>
          </div>
          <p className="text-sm md:text-base font-body text-foreground-600 max-w-md leading-relaxed">
            Fourteen meticulously organized product categories. Each spreadsheet is independently maintained with verified resources updated regularly.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {mainCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="category-card group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 rounded-lg text-center"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100/80">
                <i className={`${cat.icon} text-primary-600 text-xl md:text-2xl`}></i>
              </span>
              <span className="text-sm md:text-base font-label font-semibold text-foreground-900 whitespace-nowrap group-hover:text-primary-600 transition-colors">
                {cat.name}
              </span>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4 mt-3 md:mt-4">
          {moreCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="category-card group flex flex-col items-center gap-2.5 p-4 md:p-5 bg-background-50 rounded-lg text-center"
            >
              <span className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-secondary-100/80">
                <i className={`${cat.icon} text-secondary-600 text-lg md:text-xl`}></i>
              </span>
              <span className="text-xs md:text-sm font-label font-semibold text-foreground-800 whitespace-nowrap group-hover:text-secondary-600 transition-colors">
                {cat.name}
              </span>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href={categories[0].url}
            target="_blank"
            rel="noopener nofollow"
            className="cta-button inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-white text-sm font-label font-semibold rounded-md hover:bg-foreground-800 transition-colors"
          >
            Explore All Categories
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}